export var EVENTS = {
	UPDATED: 'UPDATED'
}